export interface ShipperInterfaceDetails {
  id: string;
  shipperInterfaceHeaderId: string;
  shippingPackSupplierId: string;
  shippingPackId: string;
  shippingPackKey: string;
  shippingPackDescription: string;
  length: number;
  width: number;
  height: number;
  volume: number;
  tare: number;
  nettWeight: number;
  grossWeight: number;
  description: string;
  additionalReference: string;
  productKey: string;
  productDescription: string;
  tariffCode: string;
  countryOfOrigin: string;
  quantity: number;
  value: number;
  commodityCode: string;
  countryOfOriginCode: string;
  unitOfMeasure: string;
}
